import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import AboutSection from "../components/AboutSection";
import MenuSection from "../components/MenuSection";
import VideoSection from "../components/VideoSection";
import TestimonialsSection from "../components/TestimonialsSection";
import FranchiseSection from "../components/FranchiseSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import { api, resolveAsset } from "../lib/api";
import { initialContent } from "../mock";

function resolveImages(content) {
  // Walk known image fields and prefix backend URL where relative
  const c = JSON.parse(JSON.stringify(content));
  if (c.brand?.logo) c.brand.logo = resolveAsset(c.brand.logo);
  if (c.hero?.bgImage) c.hero.bgImage = resolveAsset(c.hero.bgImage);
  if (c.menu?.items) c.menu.items = c.menu.items.map((i) => ({ ...i, image: resolveAsset(i.image) }));
  if (c.testimonials?.items) c.testimonials.items = c.testimonials.items.map((t) => ({ ...t, avatar: resolveAsset(t.avatar) }));
  if (c.videos?.items) c.videos.items = c.videos.items.map((v) => ({ ...v, thumbnail: resolveAsset(v.thumbnail) }));
  return c;
}

export default function HomePage() {
  const [content, setContent] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api
      .get("/content")
      .then((r) => setContent(resolveImages(r.data)))
      .catch(() => {
        // fallback to local mock if backend unavailable
        setError(true);
        setContent(initialContent);
      });
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f5ebd6]">
        <div className="text-[#a08862] text-sm tracking-tight-wide">LOADING…</div>
      </div>
    );
  }

  const sectionMap = {
    hero: <Hero hero={content.hero} logo={content.brand.logo} />,
    about: <AboutSection about={content.about} />,
    menu: <MenuSection menu={content.menu} />,
    videos: <VideoSection videos={content.videos} />,
    testimonials: <TestimonialsSection testimonials={content.testimonials} />,
    franchise: <FranchiseSection franchise={content.franchise} />,
    contact: <ContactSection contact={content.contact} />,
  };

  const defaultOrder = ["hero", "about", "menu", "videos", "testimonials", "franchise", "contact"];
  const sections = (content.sections && content.sections.length
    ? content.sections
    : defaultOrder.map((k, i) => ({ key: k, enabled: true, order: i + 1 }))
  )
    .slice()
    .filter((s) => s.enabled && sectionMap[s.key])
    .sort((a, b) => (a.order || 0) - (b.order || 0));

  return (
    <div className="min-h-screen bg-[#f5ebd6]">
      <Navbar brand={content.brand} nav={content.nav || []} />
      {sections.map((s) => (
        <React.Fragment key={s.key}>{sectionMap[s.key]}</React.Fragment>
      ))}
      <Footer brand={content.brand} contact={content.contact} footer={content.footer || {}} nav={content.nav || []} />
      {error && (
        <div className="fixed bottom-2 left-2 bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded">
          Offline: showing demo content
        </div>
      )}
    </div>
  );
}
